import { ReactNode } from 'react';

import { Root } from './styles';

export interface InnerLayoutProps {
  children?: ReactNode;
  className?: string;
}

const InnerLayout = ({ children, className }: InnerLayoutProps) => {
  return <Root className={className}>{children}</Root>;
};

export default InnerLayout;
